import { useEffect, useMemo, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { SelectInput } from '../forms';
import {
  partnerDivisionActions,
  PartnerDivisionStore,
} from '../../../partners/store/divisions/partnerDivisionStore';

// value не убираем из ComponentProps: селектор сам управляет им через addDivisionId
type DivisionSelectorProps = Omit<ComponentProps<typeof SelectInput>, 'defaultValue'> & {
  name?: string,
  /** id подразделения, которого может не быть в загруженном списке — добавим его опцией. */
  addDivisionId?: string,
  /** Подпись опции для addDivisionId. */
  addDivisionName?: string,
  /** Партнёр, чьи подразделения грузим. */
  partnerId?: string,
  /** из inject('partnerDivisionStore') */
  partnerDivisionStore?: PartnerDivisionStore,
};

const DivisionSelector = (props: DivisionSelectorProps) => {
  const {
    partnerDivisionStore, addDivisionId, addDivisionName, partnerId, name = 'divisionId', ...rest
  } = props;

  const { divisionsList, loadingDivisions } = partnerDivisionStore;

  // Мемоизированный список подразделений — стабильная ссылка массива для data между рендерами
  const divisionsListArray = useMemo(() => {
    if (divisionsList.find(v => v.id === addDivisionId)) return divisionsList;
    if (!addDivisionId) return divisionsList;
    return divisionsList.concat([{ id: addDivisionId, name: addDivisionName }]);
  }, [addDivisionId, addDivisionName, divisionsList]);

  useEffect(() => {
    if (partnerId) {
      partnerDivisionActions.getDivisions(partnerId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  return (
    <SelectInput
      { ...rest }
      name={ name }
      data={ divisionsListArray }
      dataTitle='name'
      dataValue='id'
      loading={ loadingDivisions }
      sort
      value={ addDivisionId }
    />
  );
};

export default inject('partnerDivisionStore')(observer(DivisionSelector));
